"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OverflowText = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OverflowText, _React$Component);

  function OverflowText(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "checkHasOverFlow", function () {
      // $FlowFixMe
      _this.span.scrollHeight > _this.span.clientHeight + 2 ? _this.setState({
        hasOverflow: true
      }) : _this.setState({
        hasOverflow: false
      });
    });

    _this.state = {
      hasOverflow: false
    };
    return _this;
  }

  var _proto = OverflowText.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkHasOverFlow();
  };

  _proto.componentDidUpdate = function componentDidUpdate(nextProps, nextState) {
    if (nextProps.value !== this.props.value) {
      this.checkHasOverFlow();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var value = this.props.value;
    var hasOverflow = this.state.hasOverflow;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasOverflow ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "data-workflow-table__text-has-overflow",
      title: value
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "data-workflow-table__text-container" // $FlowFixMe
      ,
      ref: function ref(span) {
        return _this2.span = span;
      }
    }, value)) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "data-workflow-table__text-container" // $FlowFixMe
      ,
      ref: function ref(span) {
        return _this2.span = span;
      }
    }, value));
  };

  return OverflowText;
}(_react["default"].Component);

var _default = OverflowText;
exports["default"] = _default;